import { axiosObject } from "../config";

export default function getDocumentById(id: any) {
  return new Promise((resolve, reject) => {
    let uri = "auction/data/resource/files/_read";
    let payload = {
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: id,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then((response) => {
        resolve(response.data.data[0]);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
